import React from 'react';

export const ArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5 13L10.9208 8.16261C10.9457 8.14221 10.9656 8.11717 10.9793 8.08914C10.9929 8.06111 11 8.03073 11 8C11 7.96927 10.9929 7.93889 10.9793 7.91086C10.9656 7.88283 10.9457 7.85779 10.9208 7.83739L5 3"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
